module.exports = __webpack_public_path__ + "img/icon_dkjl.320adb17.png";